<template>
  <div class="moduleContainer">
    <div class="MuiFormControl-root MuiTextField-root jss50 MuiFormControl-fullWidth">
      <label class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-filled MuiFormLabel-filled"
        :class="{
          'Mui-disabled': inputDisabled,
          'Mui-error': hasError,
          'MuiInputLabel-shrink': focused || inputValue
        }"
        :data-shrink="focused">
        {{ label }}
      </label>
      <div class="MuiInputBase-root MuiFilledInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
        :class="{
          'Mui-disabled': inputDisabled,
          'Mui-error': hasError,
          'Mui-focused': focused
        }">
        <input v-model="inputValue" :key="resetKey"
          :type="inputType" required=""
          class="MuiInputBase-input MuiFilledInput-input"
          :class="{
            'Mui-disabled': inputDisabled
          }"
          :disabled="inputDisabled"
          :aria-invalid="hasError"
          @input="parseInput"
          @focus="focusInput"
          @blur="blurInput">
        </input>
      </div>
    </div>
    <p v-if="hasError" class="errorMessage">
      {{ errorMessage }}
    </p>
    <p v-if="helpMessage" class="helpMessage">
      {{ helpMessage }}
    </p>
    <!-- <div>
      <div>
        <input v-model="inputValue" :key="resetKey"
          :type="inputType" required=""
          class="adaptativePlaceholderBlock"
          :class="{errorField: hasError}"
          :readonly="readonly"
          @input="parseInput"
          @blur="onBlur">
        </input>
        <label :alt="label" :placeholder="label"></label>
      </div>
    </div> -->
    <!-- <small v-if="hasError" class="d-flex text-danger"
      style="margin-bottom:1.8em;">
      {{ errorMessage }}
    </small> -->
  </div>
</template>
<script>
/** @author TLV 12/02/2021
* @brief Component for showing input text with an adaptative
*        placeholder : https://codepen.io/dannykingme/pen/IvFuB?editors=1100
*
* * JPR 07/06/2022 : Component extracted from LMSG source code, useless with Mui if integrated
*/
export default {
  name: 'AdaptativePlaceholderInput',
  props: {
    errorMessage: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    helpMessage: {
      type: String,
      default: ''
    },
    inputDisabled: {
      type: Boolean,
      default: false
    },
    inputFormating: {
      type: Function,
      default: function (val) {
        return val
      }
    },
    inputType: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number
    },
    onBlur: {
      type: Function,
      default: function () {
      }
    },
    onFocus: {
      type: Function,
      default: function () {
      }
    },
    spaceneeded: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.inputFormating(this.value)
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      focused: false,
      resetKey: false
    }
  },
  methods: {
    blurInput () {
      this.focused = false
      this.onBlur()
    },
    focusInput () {
      this.focused = true
      this.onFocus()
    },
    parseInput (event) {
      let newValue = this.inputFormating(event.target.value)
      if (newValue === this.inputValue) {
        this.inputValue = newValue
        this.resetKey = !this.resetKey
      } else {
        this.inputValue = newValue
      }
    }
  }
}
</script>
<style scoped>
.moduleContainer {
  display: flex;
  flex-direction: column;
}

.MuiFormControl-fullWidth {
  width: 100%;
}
.MuiFormControl-root {
  border: 0;
  margin: 0;
  display: inline-flex;
  padding: 0;
  position: relative;
  min-width: 0;
  flex-direction: column;
  vertical-align: top;
}

.MuiFormLabel-root {
  color: #959595;
  padding: 0;
  font-size: 1rem;
  font-family: "Ubuntu", "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1;
}
.MuiFormLabel-root.Mui-error {
  color: #959595;
}

.MuiInputLabel-root {
  display: block;
  transform-origin: top left;
}
.MuiInputLabel-formControl {
  top: 0;
  left: 0;
  position: absolute;
  transform: translate(0, 24px) scale(1);
}
.MuiInputLabel-animated {
  transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
}
.MuiInputLabel-filled {
  color: #959595;
  z-index: 1;
  transform: translate(18px, 32px) scale(1);
  pointer-events: none;
}
.MuiInputLabel-filled.MuiInputLabel-shrink {
  transform: translate(18px, 20px) scale(0.75);
}


/* MuiInputBase */
.MuiInputBase-root {
  color: rgba(0, 0, 0, 0.87);
  cursor: text;
  display: inline-flex;
  position: relative;
  font-size: 1rem;
  box-sizing: border-box;
  align-items: center;
  font-weight: 400;
  line-height: 1.1876em;
  border-radius: 5px;
  background-color: white;
}
.MuiInputBase-fullWidth {
  width: 100%;
}

.MuiInputBase-input {
  font: inherit;
  color: currentColor;
  width: 100%;
  border: 0;
  height: 1.1876em;
  margin: 0;
  display: block;
  padding: 6px 0 7px;
  min-width: 0;
  background: none;
  box-sizing: content-box;
  animation-name: mui-auto-fill-cancel;
  letter-spacing: inherit;
  animation-duration: 10ms;
  -webkit-tap-highlight-color: transparent;
}
.MuiInputBase-input::placeholder {
  color: currentColor;
  opacity: 0.42;
  transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

label[data-shrink="false"] + .MuiInputBase-formControl .MuiInputBase-input::placeholder {
  opacity: 0 !important;
}


/* MuiFilledInput */
.MuiFilledInput-root {
  border: 1px solid #E4E4E4;
    border-top-color: rgb(228, 228, 228);
    border-right-color: rgb(228, 228, 228);
    border-bottom-color: rgb(228, 228, 228);
    border-left-color: rgb(228, 228, 228);
  margin: 5px 0;
  position: relative;
  transition: background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
  border-radius: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  background-color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.MuiFilledInput-root.Mui-focused {
  border-color: #49A0A2;
}
.MuiFilledInput-root.Mui-error {
  border-color: #FF0000;
}

.MuiFilledInput-input {
  padding: 35px 18px 16px;
  border-radius: 4px;
}

.errorMessage {
  font-size: 13px;
  line-height: 1.43;
  color: red;
  margin: 10px 0;
}

.helpMessage {
  font-size: 13px;
  line-height: 15px;
  color: #959595;
  margin-top: 5px;
}
</style>
